// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2vJRV","left":"StickyBox_left__3amKg","right":"StickyBox_right__sZmev"};